// eslint-disable-next-line import/no-extraneous-dependencies
import React from 'react';
import CheckListItem from '../checklist-item/ChecklistItem';
import { AccordionItem, ChecklistItemTitle, type Task } from '../..';
// eslint-disable-next-line import/no-extraneous-dependencies
import { ErrorBoundary } from 'react-error-boundary';
import { fg } from '@atlaskit/platform-feature-flags';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';

export interface ChecklistContainerProps {
	expandedTask?: Task['id'];
	onTaskExpand: (id: Task['id']) => void;
	tasks: Task[];
}

export default ({
	tasks,
	onTaskExpand,
	expandedTask,
}: ChecklistContainerProps): React.JSX.Element => {
	const tasksJsx = (
		<>
			{tasks.map((task) => {
				const isOpen: boolean = task.id === expandedTask;
				return (
					<ErrorBoundary key={task.id} fallbackRender={() => <></>}>
						<AccordionItem expanded={isOpen} key={task.id} id={task.id}>
							<ChecklistItemTitle expanded={isOpen} onClick={onTaskExpand} {...task} />
							<CheckListItem {...task} expanded={isOpen} />
						</AccordionItem>
					</ErrorBoundary>
				);
			})}
		</>
	);

	return fg('jira_onboarding_a11y_fixes_for_quickstart') ? (
		<Box as="ul" xcss={listStyles}>
			{tasksJsx}
		</Box>
	) : (
		tasksJsx
	);
};

const listStyles = xcss({
	listStyle: 'none',
	marginTop: 'space.0',
	paddingLeft: 'space.0',
});
